import { render, staticRenderFns } from "./priceListConfigList.vue?vue&type=template&id=8d98aac2&scoped=true&"
import script from "./priceListConfigList.vue?vue&type=script&lang=js&"
export * from "./priceListConfigList.vue?vue&type=script&lang=js&"
import style0 from "./priceListConfigList.vue?vue&type=style&index=0&id=8d98aac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d98aac2",
  null
  
)

export default component.exports